<template>
  <v-app>
    <v-main class="bg-blue-900">
      <div class="py-12 mx-auto max-w-6xl">
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </div>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.v-application--wrap {
  min-height: auto !important;
}
</style>
